import { Box, Button, Typography } from '@mui/material';

const UploadHeader = ({ onCancel, onDone, hasFiles, isSubmitting }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        borderBottom: '2px solid #E8E8E8',
        px: 2,
        py: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: {
            xs: '0.85rem',
            sm: '1rem',
          },
        }}
      >
        Upload Data
      </Typography>
      <Box>
        <Button color="inherit" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!hasFiles || isSubmitting}
          onClick={onDone}
          sx={{ ml: 1 }}
        >
          {isSubmitting ? 'Processing...' : 'Done'}
        </Button>
      </Box>
    </Box>
  );
};

export default UploadHeader;
